import { Attributes, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class WACToHoldingsReconciliationReportCriteria extends ValueObject {
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";

    public rawAccountNumber: string | null = null;

    @Rules.Required()
    @Attributes.Date()
    public holdingDate: Date | null = new Date();
}